// Shamelessly copied from https://css-tricks.com/converting-color-spaces-in-javascript/
function hexToHSL (H) {
  // Convert hex to RGB first
  let r = 0
  let g = 0
  let b = 0
  if (H.length === 4) {
    r = Number('0x' + H[1] + H[1])
    g = Number('0x' + H[2] + H[2])
    b = Number('0x' + H[3] + H[3])
  } else if (H.length === 7) {
    r = Number('0x' + H[1] + H[2])
    g = Number('0x' + H[3] + H[4])
    b = Number('0x' + H[5] + H[6])
  }

  // Then to HSL
  r /= 255
  g /= 255
  b /= 255

  const cmin = Math.min(r, g, b)
  const cmax = Math.max(r, g, b)
  const delta = cmax - cmin

  let h = 0
  let s = 0
  let l = 0

  if (delta === 0) h = 0
  else if (cmax === r) h = ((g - b) / delta) % 6
  else if (cmax === g) h = (b - r) / delta + 2
  else h = (r - g) / delta + 4

  h = Math.round(h * 60)
  if (h < 0) h += 360

  l = (cmax + cmin) / 2
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
  s = +(s * 100).toFixed(1)
  l = +(l * 100).toFixed(1)

  return { h, s, l }
}


// The swatches come as a string, in the format '14k-cavan-gold:123456\n', which we need to convert to ['14K Cavan Gold', '#123456'],
const mappedSwatches = window.__initialData__?.colors.split('\n').map(swatch => swatch.split(':')).map(([key, color]) => {
  const formattedKey = key.split('').reduce((str, v, i) => {
    if (v === '-') return str.concat(' ')
    const prev = key.charAt(str.length - 1)
    if (!i || Number(prev) || prev === '-') return str.concat(v.toUpperCase())
    return str.concat(v)
  }, '')

  const hex = `#${ color.trim() }`
  const hsl = hexToHSL(hex)
  return [formattedKey, {
    hex,
    hsl
  }]
}) ?? []

const previewOptions = new Map(Object.values(window.__initialData__?.personalization?.previewOptions ?? {}).map(option => [option.name.trim(), option]))

const personalizationColors = new Map(mappedSwatches)
const personalizationFonts = new Map([
  ['Classic', 'Playfair Display'],
  ['Script', 'Petit Formal Script'],
  ['Modern', 'Oswald'],
  ['Roman', 'Roman']
])

/** These are 'family' aliases - mostly for personalization settings that have been renamed */
const personalizationAliases = new Map([
  ['Personalized Vertical Bar', 'Personalized Vertical Bar'],
  ['Personalized Coordinates Bar', 'Personalized Coordinates Bar'],
  ['Personalized Bar', 'Personalized Bar'],
  ['Personalized Rectangle', 'Personalized Rectangle'],
  ['Small Organic', 'Small Organic'],
  ['Large Organic', 'Large Organic'],
  ['Sunburst', 'Sunburst'],
  ['Small Florentine', 'Small Florentine'],
  ['Large Florentine', 'Large Florentine'],
  ['Organic Cufflinks', 'Small Organic'],
  ['Skinny Bar Vertical', 'Personalized Vertical Bar'], // old alias
  ['Bar Horizontal', 'Personalized Bar'], // old alias
  ['Ingot Bar', 'Personalized Rectangle'], // old alias
  ['Organic Petite', 'Small Organic'], // old alias
  ['Organic', 'Large Organic'], // old alias
  ['Florentine Petite', 'Small Florentine'], // old alias
  ['Florentine', 'Large Florentine'], // old alias
  ['Wide Bar Vertical', 'Personalized Vertical Bar'], // old alias
  // Customs
  ['Custom Sunburst', 'Custom Sunburst'],
  ['Custom Sunburst Charm', 'Custom Sunburst Charm'],
  ['Custom Bar', 'Custom Bar'],
  ['Custom Large Florentine', 'Custom Large Florentine'],
  ['Custom Large Organic', 'Custom Large Organic'],
  ['Custom Organic Cufflinks', 'Custom Organic Cufflinks'],
  ['Custom Rectangle', 'Custom Rectangle'],
  ['Custom Small Florentine', 'Custom Small Florentine'],
  ['Custom Small Organic', 'Custom Small Organic'],
  ['Custom Vertical Layering Bar', 'Custom Vertical Layering Bar'],
  ['Custom Diamond Florentine', 'Custom Large Florentine'],
  ['Sports Personalized Vertical Bar', 'Sports Personalized Vertical Bar'],
  ['Texas Exes Key Ring Personalization', 'Texas Exes Key Ring Personalization'],
  ['Texas A&M The Association Pendant', 'Texas A&M The Association Pendant'],
  ['Texas A&M The Association Cufflinks', 'Texas A&M The Association Cufflinks'],
  ['In House Vertical Layer Bar', 'In House Vertical Layer Bar'],
  ['In House Bar Bracelet / Necklace', 'In House Bar Bracelet / Necklace']
])

/** These are SVG component previews, so different family names can use the same component preview */
const previewComponentAliases = new Map([
  ['Sunburst', 'PreviewSunburst'],
  ['Small Organic', 'PreviewSmallOrganic'],
  ['Small Florentine', 'PreviewSmallFlorentine'],
  ['Personalized Vertical Bar', 'PreviewPersonalizedVerticalBar'],
  ['Personalized Rectangle', 'PreviewPersonalizedRectangle'],
  ['Personalized Coordinates Bar', 'PreviewPersonalizedCoordinatesBar'],
  ['Personalized Coordinates Horizontal Bar', 'PreviewPersonalizedBar'],
  ['Personalized Bar', 'PreviewPersonalizedBar'],
  ['Large Organic', 'PreviewLargeOrganic'],
  ['Large Florentine', 'PreviewLargeFlorentine'],
  // Customs
  ['Custom Sunburst', 'PreviewSunburst'],
  ['Custom Sunburst Charm', 'PreviewSunburstCharm'],
  ['Custom Small Organic', 'PreviewSmallOrganic'],
  ['Custom Small Florentine', 'PreviewSmallFlorentine'],
  ['Custom Vertical Layering Bar', 'PreviewPersonalizedVerticalBar'],
  ['Custom Rectangle', 'PreviewPersonalizedRectangle'],
  ['Custom Bar', 'PreviewPersonalizedBar'],
  ['Custom Organic', 'PreviewLargeOrganic'],
  ['Custom Florentine', 'PreviewLargeFlorentine'],
  ['Custom Large Florentine', 'PreviewLargeFlorentine'],
  ['Custom Diamond Florentine', 'PreviewLargeFlorentine'],
  ['Sports Personalized Vertical Bar', 'PreviewPersonalizedVerticalBar'],
  ['Texas Exes Key Ring Personalization', 'PreviewTexasExesKeyRing'],
  ['Texas A&M The Association Cufflinks', 'PreviewTexasAMCufflinks'],
  ['Texas A&M The Association Pendant', 'PreviewTexasAMPendant'],
  ['In House Vertical Layer Bar', 'PreviewPersonalizedVerticalBar'],
  ['In House Bar Bracelet / Necklace', 'PreviewPersonalizedBar']
])

/** Find preview options for a particular prevew name */
function findPreviewOptions (name) {
  const previewOptions = window.personalizationConfig?.previewOptions
  if (!previewOptions) throw new Error('Missing preview options from initial data.')

  const previewName = personalizationAliases.get(name.trim()) ?? personalizationAliases.get(name) ?? name
  return previewOptions.get(previewName)
}

/** Find preview component for a particular preveiw name */
function findPreviewTemplate (name) {
  console.debug(`[findPreviewTemplate] Finding preview component for ${ name }`)
  const previewOptions = window.personalizationConfig?.previewOptions
  const previewComponents = window.personalizationConfig?.previewComponentAliases
  if (!previewOptions) throw new Error('Missing preview options from initial data.')
  if (!previewComponents) throw new Error('Missing preview components from initial data.')

  const previewName = personalizationAliases.get(name.trim()) ?? personalizationAliases.get(name) ?? name
  return previewComponents.get(previewName)
}

const strictRegex = new RegExp(/[^A-Za-z0-9 .,!?@#$%^&*()_+\-=\[\]{}|;:'"\/\\<>~`]/, 'gm')

const generalRegex = new RegExp(/(\r\n|\n|\r)/, 'gm')

window.personalizationConfig = {
  personalizationColors,
  personalizationAliases,
  personalizationFonts,
  previewComponentAliases,
  previewOptions,
  findPreviewOptions,
  findPreviewTemplate
}

window.personalizationApp = new Vue({
  el: '#personalization-flyout',
  delimiters: ['${', '}'],
  filters: {
    money: value => window.Shopify?.formatMoney(value)
  },
  data: () => {
    return {
      // State
      isActive: false,
      mode: '',
      state: {
        loading: false,
        success: false,
        error: false
      },
      // Item data
      personalizationVariants: {},
      engravingOption: null,
      options: null,
      // We set this in start mode, to identify the line item we are editing
      product: null,
      lineItems: {},
      variant: null, // If we are in edit mode, we set this variant
      // Preview options
      preview: null,
      currentSide: 'front',
      input: {
        font: '',
        lines: {
          front: {},
          back: {}
        }
      }
    }
  },
  computed: {
    previewComponent () {
      if (!this.preview) {
        console.log('Missing preview.')
        return null
      }

      const alias = previewComponentAliases.get(this.preview.name.trim())
      if (alias) return alias

      const name = this.preview.name.trim().replaceAll(' ', '-').toLowerCase()
      return `preview-${ name }`
    },
    fontClass () { return `font-${ this.input.font }`.toLowerCase() },
    hasLines () {
      const hasFrontLines = this.input.lines && typeof this.input.lines.front === 'object' && Object.values(this.input.lines.front).some(line => line.length)
      const hasBackLines = this.input.lines && typeof this.input.lines.back === 'object' && Object.values(this.input.lines.back).some(line => line.length)

      return {
        front: hasFrontLines,
        back: hasBackLines,
        hasFrontLines,
        hasBackLines
      }
    },
    currentVariant () {
      // We don't allow personalization if we don't have a front _or_ back engraved variant, so we shouldn't need to check for that
      // (famous last words)

      // If we are in edit mode, we return the saved variant
      if (this.variant) return this.variant

      // If we have no front enabled, then return the f + b variant
      if (!this.personalizationVariants.enabledFrontEngraving) return this.personalizationVariants.backEngravingVariant

      // If we have no back enabled, then assume we should return f + b
      if (!this.personalizationVariants.enabledBackEngraving) return this.personalizationVariants.frontEngravingVariant

      if (!this.input) return this.personalizationVariants.backEngravingVariant

      const { hasFrontLines, hasBackLines } = this.hasLines

      // If we have only front lines, return front engraving
      if (!hasBackLines) return this.personalizationVariants.frontEngravingVariant

      // If we have only back lines, return f + b (or back)
      if (!hasFrontLines) return this.personalizationVariants.backEngravingVariant

      // Otherwise return f + b
      return this.personalizationVariants.backEngravingVariant
    },
    subtotal () {
      if (this.variant) return this.variant.final_line_price
      if (!this.currentVariant) return 0
      const variantTotal = this.currentVariant.price
      const optionsTotal = this.options.reduce((total, product) => total + product.price, 0)
      return (variantTotal + optionsTotal) * this.lineItems.variantLineItem.quantity
    },
    hasEmptyInput () {
      const inputs = Object.values(this.input.lines)
        .flatMap(value => typeof value === 'object' ? Object.values(value) : value)
        .filter(value => !!value)
      return !inputs.length
    },
    extraBackEngravingCost () {
      // If we have no front, or no back, then no need to show the difference
      if (!this.personalizationVariants.enabledFrontEngraving) return
      if (!this.personalizationVariants.enabledBackEngraving) return

      const frontVariant = this.personalizationVariants.frontEngravingVariant
      const backVariant = this.personalizationVariants.backEngravingVariant

      const extraCost = backVariant.price - frontVariant.price
      return extraCost
    }
  },
  watch: {
    isActive (active) {
      const body = document.querySelector('body')
      if (active) body.classList.add('flyout-active')
      else if (!window.cartApp.isActive) body.classList.remove('flyout-active')
    },
  },
  methods: {
    close () {
      this.isActive = false
    },
    toCapitalCase (string = '') {
      return string.split('').reduce((str, c, i) => (i === 0) || (str.charAt(i - 1) === ' ') ? str.concat(c.toUpperCase()) : str.concat(c), '')
    },
    handleLineUpdate (side, key, value) {
      // Format lines here
      let formattedValue = value.trim().replace(strictRegex, "")

      // Custom validator
      // if (this.preview?.name === 'Texas A&M The Association Cufflinks') {
      //   if (!formattedValue.startsWith('"')) {
      //     formattedValue = `"${ formattedValue }`
      //   }
      // }

      this.input.lines[side][key] = formattedValue || ''
    },
    getPreviewOptions (metadata) {
      if (!window.personalizationConfig) {
        console.warn(`Missing window.personalizationConfig data`)
        return
      }

      if (!metadata.vector) {
        console.warn('No vector found for this metadata', metadata)
        return
      }
      if (!window.personalizationConfig.personalizationAliases.has(metadata.vector)) {
        return console.warn(`Missing personalization vector key ${ metadata.vector }`)
      }

      const previewAlias = window.personalizationConfig.personalizationAliases.get(metadata.vector)
      const preview = previewOptions.get(previewAlias)
      if (!preview) {
        console.warn('Missing preview from previewOptions for', previewAlias)
      }

      if (!metadata.defaults || !metadata.defaults.personalization_side) return preview

      // TODO: This is wrong? `personalizationOptions` doesn't exist yet?
      const metadataPersonalizationSide = metadata.defaults.personalization_side
      const allowsFrontEngraving = metadataPersonalizationSide ? metadataPersonalizationSide === 'Front Side' || metadataPersonalizationSide === 'Front & Back Sides' : personalizationOptions.front
      const allowsBackEngraving = metadataPersonalizationSide ? metadataPersonalizationSide === 'Back Side' || metadataPersonalizationSide === 'Front & Back Sides' : personalizationOptions.back

      const mergedPreview = {
        ...preview,
        front: allowsFrontEngraving,
        back: allowsBackEngraving
      }

      return mergedPreview
    },
    setPreviewOptions (previewOptions) {
      if (!previewOptions) {
        console.warn('Called setPreviewOptions with no previewOptions', { previewOptions })
        return
      }

      const fonts = previewOptions.fonts.map(name => ({ name, family: personalizationFonts.get(name) })).sort((a, b) => a.name.localeCompare(b.name))

      const lines = {
        front: Object.fromEntries(previewOptions.lines.front.map(line => [line.name, ''])),
        back: Object.fromEntries(previewOptions.lines.back.map(line => [line.name, '']))
      }

      // Custom condition for presets
      // if (previewOptions.name === 'Texas A&M The Association Cufflinks') {
      //   Reflect.set(lines.back, 'Line 1', '"')
      // }

      this.preview = { ...previewOptions, fonts }

      const initialFont = fonts.length ? fonts[0].name : ''
      const initialSide = previewOptions.front ? 'front' : 'back'

      this.input = { font: initialFont, lines }
      this.currentSide = initialSide
    },
    setPreviewColors (material) {
      if (!material) return console.error('No material provided to set preview color')
      if (!personalizationColors.has(material)) return console.error('No color found for this material', material)

      const { hsl } = personalizationColors.get(material)
      document.documentElement.style.setProperty('--personalization-color-h', hsl.h)
      document.documentElement.style.setProperty('--personalization-color-s', `${ hsl.s }%`)
      document.documentElement.style.setProperty('--personalization-color-l', `${ hsl.l }%`)
    },
    setSelectedOptions () {
      const logger = this.createLogger('setSelectedOptions')

      // Now set
      logger('Original options:', this.originalSelectedOptions)
      logger('Current Variant:', this.currentVariant)
      logger('Current Mode:', this.mode)

      const isBundleProduct = window.productApp.isBundleProduct
      logger('Is Bundle:', isBundleProduct)

      if (isBundleProduct) {
        // Loop through to find the product we are customizing
        // We want the index, so we use forEach
        window.productApp.bundles.forEach((bundle, bundleIndex) => {
          bundle.items.forEach((item, itemIndex) => {
            const containsCurrentVariant = item.type === 'product' ? item.resource.variants.some(variant => variant.id === this.currentVariant.id) : item.resource.id === this.currentVariant.id
            logger('Update bundle options:', { item, containsCurrentVariant, bundleIndex, itemIndex, optionsWithValues: item.optionsWithValues })

            if (!containsCurrentVariant) return

            for (const option of item.optionsWithValues) {
              const currentValue = this.currentVariant.options[option.position - 1]
              if (currentValue) {
                logger(`Setting option ${ option.name } to ${ currentValue }`)
                window.productApp.setSelectedBundleOption(bundleIndex, itemIndex, option.name, currentValue)
              }
            }
          })
        })
      } else {
        const product = window.productApp.product
        const optionsWithValues = window.productApp.optionsWithValues

        for (const option of optionsWithValues) {
          const currentValue = this.currentVariant.options[option.position - 1]
          if (currentValue) {
            logger(`Setting option ${ option.name } to ${ currentValue }`)
            window.productApp.setSelectedOption(option.name, currentValue)
          }
        }
      }
    },
    clearSelectedOptions () {
      if (window.productApp) window.productApp.resetSelectedOptions()
    },
    createLogger (tag) {
      return (...messages) => console.debug(`[Personalization]${ tag ? `(${ tag })` : '' }`, ...messages)
    },
    createInputProperties () {
      const flattenOptions = (input, parent = '') => Object.entries(input).filter(([k, v]) => !!v).flatMap(([key, value]) => {
        if (typeof value === 'object') return flattenOptions(value, key)
        const name = parent ? `${ parent } ${ key }` : key
        return [[this.toCapitalCase(`Personalization ${ name }`), value.trim()]]
      })
      const input = Object.fromEntries(flattenOptions(this.input))
      return input
    },
    /**
     * TODO: Move this to the productApp?
     *
     * Wondering why we do this here? We could instead call the productApp with the variant we want to use, and its properties
     * to be merged, then in createLineItems loop over all variants unless we find a match to our passed in variants,
     * then use that instead?
     *
     * Thinking we can pass in array, and first createLineItems tries to math it all etc.?
     */
    // Add current variant + options data to store, and open. Can only be used on a product page!
    start ({
      /** An object containing the front + back engraving variants */
      personalizationVariants,
      /** Contains all personalization product properties */
      personalizationResources,
      /** Any other products to be added, like chain options */
      options,
      /** The resolved line items from `createLineItems` */
      lineItems
    }) {
      if (!personalizationVariants || !personalizationVariants.personalizationOptions || !options || !personalizationResources) {
        return console.error('Missing variants or options.')
      }

      this.personalizationVariants = personalizationVariants
      this.options = options
      this.lineItems = lineItems
      this.engravingOption = personalizationResources.engravingOption
      this.product = personalizationResources.product

      const material = personalizationResources.selectedOptions.find(option => option.name === 'Material')
      this.setPreviewColors(material && material.selected)

      this.setPreviewOptions(personalizationVariants.personalizationOptions)

      // this.setSelectedOptions()

      this.mode = 'start'
      this.isActive = true
    },
    // Add current variant + options data to store, and open
    edit (item) {
      const vector = item.properties._option_vector

      if (!vector) return console.error('Missing vector property from line item.')

      this.variant = item

      const previewOptions = this.getPreviewOptions({ vector })
      this.setPreviewOptions(previewOptions)

      const materialOption = item.options_with_values.find(option => option.name === 'Material')
      if (materialOption) this.setPreviewColors(materialOption.value)

      // Create an object with input values we already have - manually, for now, as we need to recreate some deep nested objects.
      Object.entries(item.properties).filter(([key]) => key.includes('Personalization') && !key.includes('option'))
        .map(([key, value]) => [this.toCapitalCase(key.replace('Personalization', '').trim()), value])
        .forEach(([key, value]) => {
          if (key.includes('Front')) {
            key = key.replace('Front', '').trim()
            return this.$set(this.input.lines.front, key, value)
          }

          if (key.includes('Back')) {
            key = key.replace('Back', '').trim()
            return this.$set(this.input.lines.back, key, value)
          }

          // probably font
          this.$set(this.input, key.toLowerCase(), value)
        })

      // TODO: We'll likely need to update this to fetch the current product JSON, as if they remove back lines, then it likely should revert to front variant
      // Only allow editing sides we have already added
      const { hasFrontLines, hasBackLines } = this.hasLines
      this.preview.front = hasFrontLines
      this.preview.back = hasBackLines
      this.currentSide = hasFrontLines ? 'front' : 'back'

      this.mode = 'edit'
      this.isActive = true
    },
    reset () {
      this.state = { loading: false, success: false, error: false }
      this.isActive = false
      this.currentSide = 'front'
      this.input = {}
      this.lineItems = {}
      this.options = null
      this.personalizationVariants = {}
      this.preview = null
      this.engravingOption = null
      this.vector = null
      this.variant = null
      this.mode = null
      // this.clearSelectedOptions()
    },
    async addToCart () {
      const logger = this.createLogger('addToCart')

      this.state = { loading: true, success: false, error: false }

      // Now use the product add to cart instead!

      try {
        // So we fetch the properties here, and the current variant
        const lineItemReplacer = {
          ...this.currentVariant,
          properties: {
            ...this.createInputProperties(),
            _option_personalized: true
          }
        }

        logger(`Creating line items with item replacements:`, lineItemReplacer)

        // Merge them into an object, then pass to createLineItems
        const { optionLineItems, bundleLineItems, variantLineItem } = window.productApp.createLineItems([lineItemReplacer])
        logger(`Created line items:`, { optionLineItems, bundleLineItems, variantLineItem })


        // Once returned, add to cart as per normal
        const items = [variantLineItem, ...bundleLineItems, ...optionLineItems]
        logger('Adding items to cart:', items)

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        })

        if (!response.ok) {
          const error = await response.json()
          throw new Error(error ? error.description : 'Failed to add item to cart.')
        }

        await window.cartApp.showAddedLines(await response.json())
        if (window.upsellApp) window.upsellApp.start(currentVariant)
        else window.cartApp.open()

        this.state = { loading: false, success: true }
        this.reset()

        // Klaviyo tracking
        window.klaviyo.push(['track', 'Added to Cart', { ...window.klaviyoItem, Personalized: true }])
      } catch (error) {
        console.error(error)
        this.state = { loading: false, success: false, error: error.message }
      }
    },
    async updateCart () {
      this.state = { loading: true, success: false, error: false }
      try {
        // We removed the `Personalization` prefix from all properties before, so we add them back now
        const personalizationProperties = this.createInputProperties()
        // Need to overwrite all personalisation options, then loop through and remove nulls
        const properties = Object.fromEntries(Object.entries({ ...this.variant.properties, ...personalizationProperties }).filter(([key, value]) => !!value))
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: this.variant.key,
            properties
          })
        })
        if (!response.ok) throw new Error(await response.json())
        await window.cartApp.updateCart(await response.json())
        window.cartApp.open()
        this.state = { loading: false, success: true, error: false }
        this.reset()
      } catch (error) {
        console.error(error)
        this.state = { loading: false, success: false, error: error.message }
      }
    }
  }
})
